import { Anchor } from "@newsela/angelou";
import PropTypes from "prop-types";

import { actionNames, objectTypes, withTrackEvent } from "@newsela/snitch";
import Clever from "./Clever.svg.jsx";
import { buttonCss } from "./CleverAnchor.style";

const propTypes = {
  children: PropTypes.string.isRequired,
  __cssFor: PropTypes.object,
};

const AnchorWithTrackEvent = withTrackEvent(Anchor);

const CleverAnchor = ({ children, __cssFor = {}, ...props }) => {
  return (
    <AnchorWithTrackEvent
      __cssFor={{ ...buttonCss, ...__cssFor }}
      icon={{
        SvgComponent: Clever,
        isIconBeforeText: true,
      }}
      objectType={objectTypes.user}
      actionName={actionNames.select}
      dataProps={{
        "data-qa-selector": "sign-in-with-clever",
      }}
      streamProperties={{
        description:
          "Select the button allowing the user to sign in with Clever",
      }}
      {...props}
    >
      <span>{children}</span>
    </AnchorWithTrackEvent>
  );
};

CleverAnchor.propTypes = propTypes;

export default CleverAnchor;
